import {
  Switch as ChakraSwitch,
  SwitchProps as ChakraSwitchProps,
} from '@chakra-ui/react';
import { forwardRef } from 'react';

export type SwitchProps = Omit<ChakraSwitchProps, 'colorScheme'> & {
  colorScheme?: 'green' | 'blue' | 'purple' | 'red' | 'yellow' | 'orange';
};

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ colorScheme = 'green', sx, ...props }, ref) => {
    // Map color scheme to theme colors
    const getCustomStyles = () => {
      const colorMap: Record<string, string> = {
        green: 'icon.green',
        blue: 'icon.blue',
        purple: 'purple.500',
        red: 'icon.red',
        yellow: 'yellow.500',
        orange: 'orange.500',
      };

      const bgColor = colorMap[colorScheme] || colorMap.green;

      return {
        '.chakra-switch__track[data-checked]': {
          bg: `${bgColor} !important`,
        },
        '.chakra-switch__thumb': {
          bg: 'white !important',
        },
        ...sx,
      };
    };

    return (
      <ChakraSwitch
        ref={ref}
        colorScheme={colorScheme}
        sx={getCustomStyles()}
        {...props}
      />
    );
  },
);

Switch.displayName = 'Switch';
